export function slugify(text: string): string {
  return text
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/['"]/g, '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

export function productSlugPath(product: { id: number; name: string }): string {
  return `${slugify(product.name)}-${product.id}`;
}

export function productSlugUrl(product: { id: number; name: string }): string {
  return `/tienda/${productSlugPath(product)}`;
}

export function parseProductId(param: string | undefined): number | null {
  if (!param) return null;
  const match = param.match(/(\d+)$/);
  if (!match) return null;
  return Number(match[1]);
}
